/* istanbul ignore file */
const state = {
  overlay: false,
};

const mutations = {
  setOverlay(st, overlay) {
    st.overlay = overlay;
  },
};

const actions = {
  async onVerifyPhone({ dispatch, rootState, commit }, {
    verifyData, onSuccess,
  }) {
    try {
      commit('setOverlay', true);

      await dispatch('verifyPhone/create',
        {
          phone: verifyData.phone,
          code: verifyData.code,
        },
        { root: true });

      const result = rootState.verifyPhone.copy;
      if (result.status === 200) {
        onSuccess();
      }
      commit('setOverlay', false);
    } catch (e) {
      commit('setOverlay', false);
      alert('Erro ao verificar celular.');
    }
  },
  async sendSmsVerification({ dispatch, rootState, commit }, phone ) {
    try {
      commit('setOverlay', true);
      await dispatch('sendSmsVerification/create', phone, { root: true });
      commit('setOverlay', false);
    } catch (e) {
      commit('setOverlay', false);
      alert('Erro ao enviar sms de verificação.');
    }
  },
};

const getters = {
  getOverlay(st) {
    return st.overlay;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
